var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgUser2Fill = function SvgUser2Fill(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 25 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M11.6 13.857v5.345h1.8v-5.345a7.2 7.2 0 0 1 6.3 7.145H5.3a7.2 7.2 0 0 1 6.3-7.145m.9-.955a5.4 5.4 0 0 1-5.4-5.4c0-2.984 2.416-5.4 5.4-5.4 2.983 0 5.4 2.416 5.4 5.4 0 2.983-2.416 5.4-5.4 5.4"
  })));
};
export default SvgUser2Fill;